<div *ngIf="!worksheets || !worksheets.length">
  <particle-file-selector [(file)]="FileToUpload"
                          [legend]="'Import Fields (Excel)'"
                          (fileChange)="onFileChange($event)"
                          [required]="true" class="flex-1-1-50 lt-lg-100">
  </particle-file-selector>
</div>
